import { useMemo } from "react";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { GestaoRecebimentoEpiDropdown } from "../../../../domain/models/gestao_recebimento_epi_dropdown";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  idsGestaoEpi: number[] | null;
  idsFuncionarios: number[] | null;
  ca: string | null;
  dataEntrega: (Date | null)[] | null;
  gestaoRecebimentoEpiDropdown: GestaoRecebimentoEpiDropdown[];
  funcionariosDropdown: FuncionarioDropDown[];
  onGestaoEpiChange: (ids: number[] | null) => void;
  onFuncionariosChange: (ids: number[] | null) => void;
  onCaChange: (ca: string | null) => void;
  onDataEntregaChange: (data: (Date | null)[] | null) => void;
  onClearFilters: () => void;
};

export const Header = ({
  idsGestaoEpi,
  idsFuncionarios,
  ca,
  dataEntrega,
  gestaoRecebimentoEpiDropdown,
  funcionariosDropdown,
  onGestaoEpiChange,
  onFuncionariosChange,
  onCaChange,
  onDataEntregaChange,
  onClearFilters,
}: Props) => {

  const selectedGestaoEpis = useMemo(() => {
    if (idsGestaoEpi === null || idsGestaoEpi.length === 0) return null;
    return gestaoRecebimentoEpiDropdown.filter(x => idsGestaoEpi.some(y => y === x.idGestaoEpi));
  }, [
    idsGestaoEpi,
    gestaoRecebimentoEpiDropdown,
  ]);

  const selectedFuncionarios = useMemo(() => {
    if (idsFuncionarios === null || idsFuncionarios.length === 0) return null;
    return funcionariosDropdown.filter(x => idsFuncionarios.some(y => y === x.idFuncionario));
  }, [
    idsFuncionarios,
    funcionariosDropdown,
  ]);

  return (
    <CascateList title="Filtros" defaultOpen={true}>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <DefaultMultiAutocomplete
            label='Nome de EPIs'
            options={gestaoRecebimentoEpiDropdown}
            getOptionLabel={x => x.nomeEpi}
            getOptionKey={x => x.idGestaoEpi}
            value={selectedGestaoEpis}
            onChange={e => onGestaoEpiChange(e !== null && e.length !== 0 ? e.map(x => x.idGestaoEpi) : null)}
          />

          <DefaultMultiAutocomplete
            label='Funcionario'
            options={funcionariosDropdown}
            getOptionLabel={x => x.nome}
            getOptionKey={x => x.idFuncionario}
            value={selectedFuncionarios}
            onChange={e => onFuncionariosChange(e !== null && e.length !== 0 ? e.map(x => x.idFuncionario) : null)}
          />

          <DefaultInput
            name='ca'
            label='Certificado de Aprovação'
            value={ca}
            onChangeValue={onCaChange}
          />

          <DefaultDateRangePickerInput
            label="Data de Entrega"
            dataDe={dataEntrega?.[0] ?? null}
            dataAte={dataEntrega?.[1] ?? null}
            onChange={(de, ate) => {
              if (de === null && ate === null) {
                onDataEntregaChange(null);
              }
              else if (de === null) {
                onDataEntregaChange([de, null]);
              }
              else if (ate === null) {
                onDataEntregaChange([null, ate]);
              }
              onDataEntregaChange([de, ate]);
            }}
          />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}